import { IDashboardNutritionPlan, IDashboardSeedPlan } from "../types";
import { NotificationGroup } from "./types";

export function checkPlansToRecalculate(nutrition: IDashboardNutritionPlan[] = [], seeds: IDashboardSeedPlan[] = []): NotificationGroup {

    const issues = nutrition.map(p => ({ name: p.PlanName, icon: p.Manure ? "manure" : "fertiliser", recalc: p.ShouldRecalculate }))
        .concat(seeds.map(p => ({ name: p.PlanName, icon: "seed", recalc: p.ShouldRecalculate })))
        .filter(p => p.recalc)

    if (!issues.length) return null;

    let details = issues.map(i => {
        return {
            text: `${i.name}&nbsp;<i class='icon icon-stock-${i.icon}'></i>`
        };
    });

    details = details.sort((d1, d2) => d1.text.localeCompare(d2.text));

    return {
        id: "plan-recalc",
        summary: "Some plans must be recalculated",
        description: `
            <p>The following plans should be recalculated, because they apply to crops that have been modified since those plans were last calculated.</p>
            `,
        error: false,
        details: details,
    };



}
